import { memo, useState } from 'react';
// import Widget from './Doughnut';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import LightBox from 'components/ui/dialogs/LightBox';
import moment from 'moment';
import CurrencyFormat from 'components/ui/text-formats/CurrencyFormat';

export default memo(function SalaryForStaff({ data, open, handleClose }) {
  const { t } = useTranslation();
  const [openImageModal, setOpenImageModal] = useState(false);
  const [itemData, setItemData] = useState({});

  const percent =
    (data?.report?.stats?.total_minutes /
      data?.report?.stats?.planned_minutes) *
    100;
  console.log(percent);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        maxWidth='xl'
        style={{ zIndex: 100 }}
        disableEscapeKeyDown={true}
        PaperProps={{ className: '!base-border !shadow-none' }}
      >
        <DialogTitle
          id='alert-dialog-title'
          className='!bg-gray-100 !text-center !mb-2'
        >
          <span>{data?.user_name || ''}</span>
        </DialogTitle>

        <DialogContent className='!relative'>
          <div className='h-full relative'>
            <div className='h-full mb-8'>
              {/* <div className='text-lg font-semibold mb-2 mt-4'>{office}</div> */}
              <div className='h-[calc(100%-28px)] flex gap-3 pt-2'>
                <div className='min-w-96 w-1/3'>
                  {/* <Widget
                    data={{ ...data, date: data?.report?.month }}
                    stats={data?.report?.stats}
                  /> */}
                  <div className='w-full flex items-center justify-center p-4 mb-2'>
                    {data?.report?.image ? (
                      <img
                        src={`${data?.report?.image}`}
                        className='w-24 h-24 object-cover transition-all rounded-full cursor-pointer hover:brightness-50'
                        alt=''
                        onClick={() => {
                          setOpenImageModal(true);
                          setItemData({
                            image: data?.report?.image,
                            name: data?.user_name,
                            time: 'profile',
                          });
                        }}
                      />
                    ) : (
                      <div>
                        <i className='bi bi-no-image' />
                      </div>
                    )}
                  </div>
                  <div className='w-full grid grid-cols-2 gap-2'>
                    {data?.report?.stats
                      ? Object?.entries?.(data?.report?.stats)?.map(
                          ([name, value]) => (
                            <div key={name} className='max-h-20 mb-2'>
                              <div className='bg-slate-50 p-4 rounded-md'>
                                <div className='font-bold text-gray-500'>
                                  {t(`boss.offices.workStatuses.${name}`)}
                                </div>
                                <div className='text-[20px] font-bold'>
                                  {value ? Number(Number(value).toFixed(2)) : 0}{' '}
                                  {t('common.fields.mins')}
                                </div>
                              </div>
                            </div>
                          )
                        )
                      : ''}
                  </div>
                  <div className='my-10'>
                    <div className='w-full flex gap-1 items-center'>
                      <div className=''>0</div>
                      <div className='bg-blue-100 h-3  grow rounded-full'>
                        <div
                          style={{
                            width: `${percent}%`,
                          }}
                          className='bg-blue-600 h-3 grow rounded-full'
                        />
                        <div className='w-full relative'>
                          <div
                            style={{
                              left: `${percent}%`,
                            }}
                            className='whitespace-nowrap -translate-x-1/2 absolute top-2 left-1/2'
                          >
                            <CurrencyFormat
                              value={Number(
                                (percent * data?.report?.salary) / 100
                              )}
                              suffix={` ${data?.report?.valute}`}
                              decimalScale={2}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='whitespace-nowrap'>
                        <CurrencyFormat
                          value={data?.report?.salary}
                          suffix={` ${data?.report?.valute}`}
                          decimalScale={2}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-span-2 flex-grow'>
                  <TableContainer className='!base-border !shadow-none !h-full'>
                    <Table className='!bg-white' stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell className='!bg-gray-50'>#</TableCell>
                          <TableCell className='!bg-gray-50'>
                            {t('common.fields.date')}
                          </TableCell>
                          <TableCell className='!bg-gray-50'>
                            {t('boss.offices.workStatuses.planned_minutes')}
                          </TableCell>
                          <TableCell className='!bg-gray-50'>
                            {t('boss.offices.workStatuses.total_minutes')}
                          </TableCell>
                          <TableCell className='!bg-gray-50'>
                            {t('boss.offices.workStatuses.under_minutes')}
                          </TableCell>
                          <TableCell className='!bg-gray-50'>
                            {t('common.table.scheduleTime')}
                          </TableCell>
                          <TableCell className='!bg-gray-50'>
                            {t('common.table.checkIn')}
                          </TableCell>
                          <TableCell className='!bg-gray-50'>
                            {t('common.table.checkOut')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className='overflow-hidden'>
                        {data?.report?.list?.map((row, index) => {
                          const time1 = moment(
                            `${row?.date} ${row?.schedule?.start}`,
                            'YYYY-MM-DD HH:mm'
                          );
                          const time2 = moment(
                            `${row?.date} ${row?.attendance?.start}`,
                            'YYYY-MM-DD HH:mm'
                          );
                          const time3 = moment(
                            `${row?.date} ${row?.schedule?.end}`,
                            'YYYY-MM-DD HH:mm'
                          );
                          const time4 = moment(
                            `${row?.date} ${row?.attendance?.end}`,
                            'YYYY-MM-DD HH:mm'
                          );

                          const isAfter = !time1.isBefore(time2);

                          const isBefore = !time3.isAfter(time4);

                          return (
                            <TableRow
                              key={row.id}
                              hover
                              className='cursor-pointer'
                            >
                              <TableCell size='small'>
                                <div className='min-h-[28px] h-full flex items-center'>
                                  {index + 1}
                                </div>
                              </TableCell>
                              <TableCell size='small'>
                                {moment(row?.date, 'YYYY-MM-DD').format(
                                  'DD.MM.YYYY'
                                )}
                              </TableCell>
                              <TableCell size='small'>
                                {row?.planned
                                  ? Number(Number(row?.planned)?.toFixed(2))
                                  : '0'}
                              </TableCell>
                              <TableCell size='small'>
                                {row?.worked
                                  ? Number(Number(row?.worked)?.toFixed(2))
                                  : '0'}
                              </TableCell>
                              <TableCell size='small'>
                                {row?.diff
                                  ? Number(Number(row?.diff)?.toFixed(2))
                                  : '0'}
                              </TableCell>
                              <TableCell
                                size='small'
                                className='!whitespace-nowrap'
                              >
                                {row?.day_of ? (
                                  <span className='font-bold'>
                                    {t('boss.offices.statuses.day_off')}
                                  </span>
                                ) : (
                                  `${row?.schedule?.start}-${row?.schedule?.end}`
                                )}
                              </TableCell>
                              <TableCell
                                size='small'
                                className='!whitespace-nowrap'
                              >
                                <div className='flex items-center justify-between'>
                                  <span
                                    className='mr-2'
                                    style={{
                                      color: isAfter ? 'green' : 'red',
                                    }}
                                  >
                                    {row?.attendance?.start}
                                  </span>

                                  {row?.attendance?.start_image ? (
                                    <Button
                                      size='small'
                                      color='info'
                                      variant='contained'
                                      className='!max-w-[45px]'
                                      onClick={() => {
                                        setOpenImageModal(true);
                                        setItemData({
                                          image: row?.attendance?.start_image,
                                          name: row?.user,
                                          time: row?.attendance?.start,
                                        });
                                      }}
                                    >
                                      <i className='bi bi-person-bounding-box' />
                                    </Button>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </TableCell>
                              <TableCell
                                size='small'
                                className='!whitespace-nowrap'
                              >
                                <div className='flex items-center justify-between'>
                                  <span
                                    className='mr-2'
                                    style={{
                                      color: isBefore ? 'green' : 'red',
                                    }}
                                  >
                                    {row?.attendance?.end}
                                  </span>

                                  {row?.attendance?.end_image ? (
                                    <Button
                                      size='small'
                                      color='info'
                                      variant='contained'
                                      className='!max-w-[45px]'
                                      onClick={() => {
                                        setOpenImageModal(true);
                                        setItemData({
                                          image: row?.attendance?.end_image,
                                          name: row?.user,
                                          time: row?.attendance?.end,
                                        });
                                      }}
                                    >
                                      <i className='bi bi-person-bounding-box' />
                                    </Button>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {openImageModal && itemData?.image ? (
        // yet-another-react-lightbox
        <LightBox
          isOpen={openImageModal}
          style={{ zIndex: 9999999 }}
          captions={[`${itemData?.name} - ${itemData?.time}`]}
          titles={[`${itemData?.name} - ${itemData?.time}`]}
          images={[`${process.env.REACT_APP_BACKEND_URL}${itemData?.image}`]}
          photoIndex={0}
          setIsOpen={() => {
            setOpenImageModal(false);
            setItemData({});
          }}
        />
      ) : null}
    </>
  );
});
